export default "__VITE_ASSET__BXVOr0IL__"